<template>
    <div>
        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>
        

        <div class="p-6">
            <form @submit.prevent="submitForm" class="max-w-md space-y-4">
                <div>
                    <label for="document-name" class="mb-1 block text-sm font-medium text-gray-700">
                        Nome documento
                    </label>
                    <input
                        id="document-name"
                        type="text"
                        v-model="text"
                        required
                        class="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                    />
                </div>
                <div
                    class="flex cursor-pointer flex-col items-center justify-center rounded-md border-2 border-dashed p-6 text-sm text-gray-600"
                    :class="isDragging ? 'border-indigo-500 bg-indigo-50' : 'border-gray-300'"
                    @dragover.prevent="isDragging = true"
                    @dragleave.prevent="isDragging = false"
                    @drop.prevent="onDrop"
                    @click="$refs.fileInput.click()"
                >
                    <span v-if="file">{{ file.name }}</span>
                    <span v-else>Trascina qui un file o clicca per selezionarlo</span>
                    <input ref="fileInput" type="file" class="hidden" @change="onFileChange" />
                </div>
                <PrimaryButton type="submit">Invia</PrimaryButton>
            </form>

            <div v-if="postResponse" class="mt-4 max-w-md rounded-md bg-gray-100 p-4">
                <pre class="whitespace-pre-wrap text-sm">{{ postResponse }}</pre>
            </div>
        </div>


        
    </div>
</template>

<script>
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import axios from 'axios';

export default {
    components: {
        BreadCrumbs,
        PrimaryButton,
    },
    
    data() {
        return {
            text: '',
            postResponse: '',
            file: null,
            isDragging: false,
        };
    },
    mounted() {
        
    },
    beforeUnmount() {
        
    },
    computed: {
        
        navigation() {
            return [
                {
                    name: 'Dashboard',
                    href: route('dashboard'),
                },
                {
                    name: 'Riconoscimento Documenti',
                    href: route('modules.home', 'riconoscimento-documenti'),
                },
            ];
        },
    },
    methods: {
        onDrop(event) {
            this.isDragging = false;
            this.file = event.dataTransfer.files?.[0] ?? null;
        },
        onFileChange(event) {
            this.file = event.target.files?.[0] ?? null;
        },

        async submitForm() {
            this.postResponse = '';
            try {
                const formData = new FormData();
                formData.append('text', this.text);
                if (this.file) {
                    formData.append('document', this.file);
                }
                const response = await axios.post(route('modules.gemini.chat'), formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }).then((response) => {
                    const data = response?.data ?? '';
                    this.postResponse = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
                });

                console.log(response);
            } catch {
                console.error("Errore durante l'invio del modulo","error");
            } finally {
                this.text = '';
                this.file = null;
                if (this.$refs.fileInput) this.$refs.fileInput.value = '';
            }
        },
       
    },
};
</script>
